
import React from 'react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { LogOut } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface LogoutButtonProps {
  onLogout: () => Promise<void>;
  isLoggingOut: boolean;
}

const LogoutButton = ({ onLogout, isLoggingOut }: LogoutButtonProps) => {
  const isMobile = useIsMobile();
  
  const handleLogout = () => {
    if (localStorage.getItem("userSessionId")) {
      localStorage.removeItem("userSessionId");
    }
    onLogout();
  };

  return (
    <div className="py-1">
      <DropdownMenuItem
        onClick={handleLogout}
        disabled={isLoggingOut}
        className={`px-2 ${isMobile ? 'py-3' : 'py-2'} hover:bg-gray-50 text-red-600 cursor-pointer`}
      >
        <div className="flex items-center w-full">
          <LogOut className="h-5 w-5 mr-3" />
          <span className={`${isMobile ? 'text-base' : 'text-sm'}`}>
            {isLoggingOut ? "Logging out..." : "Sign Out"}
          </span>
        </div>
      </DropdownMenuItem>
    </div>
  );
};

export default LogoutButton;
